export default __webpack_public_path__ + "static/media/units-left-4.203f06dd.svg";